<!-- <div id="loader" *ngIf="globalsevice.HideLoader">
    <img src="./assets/img/loader.svg" alt="">
</div> -->

<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <img src="./assets/img/loader.svg" alt="">
    </div>
</div>